import React, { useState, useEffect, useCallback } from 'react';
import { API_ADDRESS, PAGE_TITLE_BASE } from './constants.js';
import { useParams } from "react-router-dom";
import { InstagramEmbed } from 'react-social-media-embed';
import { useNavigate } from "react-router";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Icon, Dimmer, Loader, Segment, Card, CardContent, CardHeader } from 'semantic-ui-react'
import tippy from 'tippy.js';
import { ConcertCard } from './ConcertCard';
import ReactDOMServer from "react-dom/server";
import { ConcertMap } from './ConcertMap';
import { PlaylistCard } from './PlaylistCard';

export function Act(props) {
  const navigate = useNavigate();
  const {id} = useParams();
  const [loading, setLoading] = useState(true);
  const [act, setAct] = useState({});
  const [name, setName] = useState('Act');
  const [concerts, setConcerts] = useState({});

  document.title = name + ' | ' + PAGE_TITLE_BASE;

  const search = useCallback(() => {  
    var url = `${API_ADDRESS}/act/${id}`;

    fetch(url)
      .then(function(response) {
        return response.json()
      })
      .then(function(json) {
        setAct(json);
        let concerts = {};
        json.concerts.map(function(concert) {
          concerts[concert.concert_id] = concert;
          return concert;
        });
        setConcerts(concerts);
        setName(json.name);
        setLoading(false);
      })
      .catch(function(ex) {
        setLoading(false);
        console.log(ex);
      })
  }, [id]); 

  useEffect(() => { if(loading) { search() } }, [loading, search])

  const onClickHandler = (e, link) => {
    if(e.ctrlKey || e.metaKey){
      window.open(link, '_blank');
    } else {
      navigate(link);
    }
  }

  return (
    <div>
      <Segment className="browse-table-segment">
        <Dimmer active={loading}>
          <Loader size='large'>Loading</Loader>
        </Dimmer>
        <h1>{name}</h1>
        {act === {} && 
          <Card color='orange' style={{width:'100%'}}>
            <CardContent>
              <CardHeader>No act found</CardHeader>
            </CardContent>
          </Card>
        }
        <div className="artist-links">
          {'spotify' in act &&
            <div>
              <iframe data-testid="embed-iframe" style={{borderRadius: "12px"}} src={"https://open.spotify.com/embed/artist/" + act.spotify} width="500" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title="spotify"></iframe>
            </div>
          }
          {'instagram' in act &&
            <div>
              <InstagramEmbed url={"https://www.instagram.com/" + act.instagram} width={500}/>
            </div>
          }
          {'website' in act &&
            <div>
              <a href={act.website} target="_blank" rel="noreferrer" style={{ fontSize: "xx-large" }}><Icon name="globe"/>Website</a>
            </div>
          }
        </div>
        {'artists' in act &&
          <div className="artists-section">
            <h2>Artists</h2>
            <div className="Cards">
              {act.artists.map(function(artist, i) {
                let color = 'orange';
                if(i % 7 === 1) { color = 'teal'; }
                if(i % 7 === 2) { color = 'purple'; }
                if(i % 7 === 3) { color = 'green'; }
                if(i % 7 === 4) { color = 'yellow'; }
                if(i % 7 === 5) { color = 'red'; }
                if(i % 7 === 6) { color = 'pink'; }

                return <Card key={artist.artist_id}
                  color={color}
                  style={{width: '290px'}}
                  onClick={(e) => onClickHandler(e, '/artist/' + artist.artist_id)}
                >
                  <CardContent>
                    <CardHeader>{'first_name' in artist && <>{artist.first_name} </>}{artist.last_name}</CardHeader>
                  </CardContent>
                </Card>
              })}
            </div>
          </div>
        }
        <div className='calendar'>
          <h1>Concert Calendar</h1>
          <div className='demo-app-main'>
            <FullCalendar
              plugins={[dayGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: ''
              }}
              editable={false}
              selectable={false}
              selectMirror={false}
              dayMaxEvents={false}
              weekends={true}
              firstDay={1}
              showNonCurrentDates={false}
              navLinks={false}
              slotEventOverlap={false}
              dayHeaderFormat={{weekday: 'long'}}
              events={act.concerts}
              locale={'en-gb'}
              height={'500px'}
              eventDisplay={'block'}
              eventContent={renderEventContent}
              eventDidMount={ (info) => {
                tippy(info.el, {
                  trigger: 'click',
                  touch: 'hold',
                  allowHTML: true,
                  content:
                     ReactDOMServer.renderToString(<ConcertCard single_concert={concerts[info.event.extendedProps.concert_id]}/>)
               });
            }}
            />
          </div>
        </div>
        {(act.markers && Object.keys(act.markers).length > 0) &&
          <ConcertMap markers={act.markers} title={'Upcoming Concerts Map'}/>
        }
        {(act.playlist && Object.keys(act.playlist).length > 0) &&
          <div className='playlist'>
            <h1>Latest Releases</h1>
            <p>We maintain a playlist of all the latest releases from the British vocal jazz scene. The following tracks by this act have been featured on the playlist:</p>
            <div className="Cards">
              {Object.keys(act.playlist).length > 0 && Object.keys(act.playlist).sort().reverse().map(function(date, i) {
                let entries_for_date = act.playlist[date];
                return <PlaylistCard key={date} date={date} playlist={entries_for_date} i={i}/>
              })}
              {Object.keys(act.playlist).length === 0 &&
                <b>No results</b>
              }
            </div>
          </div>
        }
      </Segment>
    </div>
  );
}


function renderEventContent(eventInfo) {
  return (
    <>
      <b>{eventInfo.timeText}</b><span> </span>
      <i>{eventInfo.event.title}</i>
    </>
  )
}